import { render, staticRenderFns } from "./Intelligent.vue?vue&type=template&id=ab25867c&scoped=true&"
import script from "./Intelligent.vue?vue&type=script&lang=js&"
export * from "./Intelligent.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent.vue?vue&type=style&index=0&id=ab25867c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25867c",
  null
  
)

export default component.exports